const level = 3;
const Promocode = {
  path: "",
  name: "",
  redirect: "/promocode",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      name: "",
      component: () => import("@/views/pages/promocode"),
      meta: {
        requiresAuth: true,
        activeUrl: "/promocode",
        parent: "/promocode",
        lv: level,
      },
    },
    {
      path: "/promocode/details/:id",
      name: "Promocode Detail",
      component: () => import("@/views/pages/promocode/promocodedetail"),
      meta: {
        requiresAuth: true,
        activeUrl: "/promocode",
        isChildren: true,
        lv: level,
      },
    },
    {
      path: "/promocode/details/:id/checkcode",
      name: "Promocode Detail Check",
      component: () =>
        import("@/views/pages/promocode/promocodedetail/checkcode"),
      meta: {
        requiresAuth: true,
        activeUrl: "/promocode",
        isChildren: true,
        lv: level,
      },
    },
  ],
  meta: { requiresAuth: true },
};
export default Promocode;
